import moment from 'moment'
import type { History } from '../types'
import api from './apiClient'

type HistoriesFindResponse = { data: History[]; total?: number; limit?: number; skip?: number }

function qp(key: string, value: string | number): string {
  return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
}

function buildHistoriesDayUrl(
  vehicleId: string,
  day: string,
  skip: number,
  limit: number,
  lean: 0 | 1
): string {
  const start = moment(day, 'YYYY-MM-DD').startOf('day').valueOf()
  const end = moment(day, 'YYYY-MM-DD').endOf('day').valueOf()
  const parts = [
    qp('vehicleId', vehicleId),
    qp('timestamp[$gte]', start),
    qp('timestamp[$lte]', end),
    qp('$sort[timestamp]', 1),
    qp('$limit', limit),
    qp('$skip', skip),
  ]
  if (lean === 1) parts.push(qp('lean', 1))
  return `/histories?${parts.join('&')}`
}

export type HistoriesDayResult = {
  rows: History[]
  total: number
  limit: number
  skip: number
}

export const historiesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHistoriesForDay: builder.query<
      HistoriesDayResult,
      { vehicleId: string; day: string; skip?: number; limit?: number; lean?: 0 | 1 }
    >({
      query: ({ vehicleId, day, skip = 0, limit = 2000, lean = 1 }) => ({
        url: buildHistoriesDayUrl(vehicleId, day, skip, limit, lean),
        method: 'GET',
      }),
      transformResponse: (raw: HistoriesFindResponse | History[]) => {
        if (Array.isArray(raw)) {
          return { rows: raw, total: raw.length, limit: raw.length, skip: 0 }
        }
        const rows = raw?.data ?? []
        return {
          rows,
          total: raw?.total ?? rows.length,
          limit: raw?.limit ?? rows.length,
          skip: raw?.skip ?? 0,
        }
      },
    }),
  }),
  overrideExisting: true,
})

export const { useGetHistoriesForDayQuery, useLazyGetHistoriesForDayQuery } = historiesApi
